"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.redirectToOAuthEpic = void 0;

var _reduxObservable = require("redux-observable");

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _filter = require("rxjs/operators/filter");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _mergeMap = require("rxjs/operators/mergeMap");

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var redirectToOAuthEpic = function redirectToOAuthEpic($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.EspSyncOAuthActionType.REDIRECT_TO_OAUTH).pipe((0, _filter.filter)(function () {
    var status = (0, _selectors.getRedirectToOAuthRequestStatus)(getState());
    return _RequestStatusTypeFilters.ALLOW_MULTIPLE.indexOf(status) !== -1;
  }), (0, _mergeMap.mergeMap)(function (action) {
    var data = action.payload;
    return (0, _fromPromise.fromPromise)(_API.default.getOAuthUrl(data)).pipe((0, _map.map)(function (response) {
      var authorizeUrl = response.authorizeUrl;
      window.top.location.href = authorizeUrl;
      return _actions.RedirectToOAuth.success(response, data);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.RedirectToOAuth.failure(error, data));
    }), (0, _startWith.startWith)(_actions.RedirectToOAuth.request(data)));
  }));
};

exports.redirectToOAuthEpic = redirectToOAuthEpic;

var _default = (0, _reduxObservable.combineEpics)(redirectToOAuthEpic);

exports.default = _default;